import React, { useState }  from 'react';
import { Button } from 'react-bootstrap';
import { ICON_PREV_ALT, ICON_NEXT_ALT } from '../extras/icons';
import { PROFILE_OGA, PROFILE_SISTEMAS } from '../../data/profiles';
import WorkRow from './WorkRow';

const WorkList = props => {

    // Tomo los props
    const { 
        actualPage,
        audiences, 
        authUser,
        handleSearch, 
        isFirst,
        isLast,
        totalPages
    } = props;

    // Inicializo el state local
    const [search] = useState('');

    const pageSize = 20;

    // Manejo la búsqueda
    const handlePrev = () => {
        handleSearch({
            page: actualPage - 1,
            paging: `${actualPage - 1},${pageSize}`,
            search,
            size: pageSize,
            sort: 'id:asc',
        });
    };
    const handleNext = () => {
        handleSearch({
            page: actualPage + 1,
            paging: `${actualPage + 1},${pageSize}`,
            search,
            size: pageSize,
            sort: 'id:asc',
        });
    };

    // Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-body">
                    {   audiences && audiences.length > 0 ? (
                            <>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-sm table-hover" id="dataTable" width="100%" cellSpacing="0">
                                        <thead className="thead-light">
                                            <tr>
                                                {   authUser.perfil.id === PROFILE_OGA || authUser.perfil.id === PROFILE_SISTEMAS ? (
                                                        <th></th>
                                                    ) : null
                                                }
                                                <th className="text-center">#</th>
                                                {   authUser.perfil.id === PROFILE_OGA || authUser.perfil.id === PROFILE_SISTEMAS ? (
                                                        <React.Fragment>
                                                            <th className="text-center">Ingreso</th>
                                                            <th className="text-center">Solicitante</th>
                                                            <th className="text-center">Estado</th>
                                                        </React.Fragment>
                                                    ) : (
                                                        <th className="text-center">Inicio</th>
                                                    )
                                                }
                                                <th className="text-center">Legajo</th>
                                                <th className="text-center">Tipo</th>
                                                <th className="text-center">Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {   audiences.map(audience => (
                                                    <WorkRow
                                                        audience={audience}
                                                        authUser={authUser}
                                                        key={`audienceWork${audience.id}`}
                                                    />
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-12">
                                        {!isFirst ? (
                                            <Button
                                                className="btn-circle mr-2"
                                                onClick={handlePrev}
                                                variant="primary"
                                            >
                                                <ICON_PREV_ALT />
                                            </Button>
                                        ) : null}

                                        <Button variant="primary" disabled>
                                            {actualPage + 1} de {totalPages}
                                        </Button>

                                        {!isLast ? (
                                            <Button
                                                className="btn-circle ml-2"
                                                onClick={handleNext}
                                                variant="outline-primary"
                                            >
                                                <ICON_NEXT_ALT />
                                            </Button>
                                        ) : null}
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="alert alert-info">
                                        Por el momento no hay solicitudes pendientes de Análisis
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default WorkList;